export const REQUEST_SUCCESS = 'ok';
export const REQUEST_FAILED = 'ko';

export const DEFAULT_USER_COUNTRY = 'ES';
export const COUNTRY_US = 'US';

export const LANG_EN = 'en';
export const LANG_ES = 'es';
export const LANG_DE = 'de';
export const LANG_IT = 'it';
export const LANG_FR = 'fr';
export const LANG_PT = 'pt';
export const APP_LANGUAGES: string[] = [LANG_ES, LANG_EN, LANG_FR, LANG_PT, LANG_IT];

export const EUR = 'eur';
export const USD = 'usd';

export const PRODUCT_CATEGORY_PREPAID_SMS = 'prepaid-sms';
export const PRODUCT_CATEGORY_PREPAID_EMAIL = 'prepaid-email';
export const PRODUCT_CATEGORY_LITE = 'lite';
export const PRODUCT_CATEGORY_PRO = 'pro';
export const PRODUCT_CATEGORY_TOTAL = 'total';
export const PRODUCT_CATEGORY_FREEMIUM = 'freemium';
export const PRODUCT_CATEGORY_APPSUMO = 'appsumo';
export const PRODUCT_CATEGORY_SUSPENDED = 'suspended';

export const PRODUCT_PAID_EXTERNAL = 'external';
export const PRODUCT_CORE = 'core';

export const PRODUCT_CATEGORY_TYPE_EMAIL = 'emailMarketing';
export const PRODUCT_CATEGORY_TYPE_SMS = 'smsMarketing';
export const PRODUCT_CATEGORY_TYPE_PREPAID = 'prepaid';
export const SHOW_PREPAID_EMAIL_TAB = false;

export const PRIVATE_NAVIGATION_TAB_PRODUCTS = 'products';
export const PRIVATE_NAVIGATION_TAB_ACCOUNT = 'account';
export const PRIVATE_NAVIGATION_TAB_RATE = 'my-rate';
export const PRIVATE_NAVIGATION_TAB_INVOICES = 'my-invoices';
export const PRIVATE_NAVIGATION_MY_ACCOUNT = 'my-account';

export const DEFAULT_USER_CURRENCY = EUR;
export const DEFAULT_CURRENCY_RESOLUTION_FOR_PRICES = 2;
export const DEFAULT_CURRENCY_RESOLUTION_FOR_METERED = 5;

export const STRIPE_METHOD_DIRECT = 'direct';
export const STRIPE_METHOD_CHECKOUT = 'checkout';

export const UNKNOWN = 'unknown';
export const UNKNOWN_DATA = '---';

export const DEFAULT_ORIGIN_FORM = UNKNOWN;
export const DEFAULT_GROUP_ID = UNKNOWN;
export const DEFAULT_COUNTRY_ID = UNKNOWN;
export const DEFAULT_PHONE = '';
export const DEFAULT_USER_NAME = UNKNOWN;
export const DEFAULT_USER_LANGUAGE_FOR_CONTACT = UNKNOWN;

export const USAGE_LICENSED = 'licensed';
export const USAGE_METERED = 'metered';

export const PENDING = 'pending';
export const ACTIVE = 'active';
export const CANCELLED = 'cancelled';
export const PROCESSING = 'processing';
export const INCOMPLETE = 'incomplete';

export const DATE_UNKNOWN = '???';

export const BILLING_MODE_MONTH = 'month';
export const BILLING_MODE_YEAR = 'year';
export const BILLING_MODE_UNIQUE = 'unique';
export const INTERVAL_COUNT_FOR_BILLING_MONTH = 1;
export const INTERVAL_COUNT_FOR_BILLING_YEAR = 12;
export const INTERVAL_COUNT_FOR_BILLING_UNIQUE = 0;
export const BILLING_MODE_YEAR_FIXED_DISCOUNT_PERCENT = '10';

export const DEFAULT_MISSING_EMAIL = 'unknown@example.com';

export const PRODUCT_FREE = 'FREE';
export const PRODUCT_LITE = 'LITE';
export const PRODUCT_PRO = 'PRO';
export const PRODUCT_TOTAL = 'TOTAL';
export const PRODUCT_FREE_PRICE = '0,00';

export const UPDATE_PRODUCTS_FAKE_ID = 'mamarracho';

export const NEW_ACCOUNT_DATE_FORMAT = 'YYYY-MM-DD H:m:s';

export const AUTOMATIC_COUPON = 'automatic';

export const MAX_CHECKS_CIF = 5;

export const ROL_ADM_MDIRECTOR_NEWFREE = 'adm_mdirector_newfree' as string;
export const ROL_ADM_MDIRECTOR = 'adm_mdirector' as string;

export const ROL_STD_MDIRECTOR = 'std_mdirector' as string;
export const ROL_REPORT_MDIRECTOR = 'report_mdirector' as string;
export const ROL_ANALYST_MDIRECTOR = 'analyst_mdirector' as string;
export const ROL_NDC_MDIRECTOR = 'ndc_mdirector' as string;

export const ROL_DB_MDIRECTOR = 'db_mdirector' as string;

export const ROL_CPM_MDIRECTOR = 'cpm_mdirector' as string;
export const ROL_CPU_MDIRECTOR = 'cpu_mdirector' as string;
export const ROL_GCYC_MDIRECTOR = 'gcyc_mdirector' as string;
export const ROL_CPM_REPORT_MDIRECTOR = 'cpm_report_mdirector' as string;
